const api = require('./app/canvas-api/api');

module.exports = {
    api
};
